/* Newsletter forms -> newsletter Worker (news.uncorkme-now.com/api/subscribe).
   Markup: snippets/ucmn-nl-attrs.liquid. Plain form post, so no CORS preflight.
   Several sections load this file on one page; each form is bound only once. */
(function () {
  function message(form, text, isError) {
    var box = form.parentElement.querySelector('[data-ucmn-nl-msg]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-ucmn-nl-msg', '');
      if (form.dataset.msgClass) box.className = form.dataset.msgClass;
      form.insertAdjacentElement('afterend', box);
    }
    box.textContent = text;
    box.setAttribute('role', isError ? 'alert' : 'status');
    box.hidden = false;
  }
  function bind(form) {
    if (form.dataset.ucmnNlBound) return;
    form.dataset.ucmnNlBound = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      fetch(form.action, { method: 'POST', body: new URLSearchParams(new FormData(form)) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { form.hidden = true; message(form, form.dataset.ok, false); }
          else { message(form, form.dataset.err, true); }
        })
        .catch(function () { message(form, form.dataset.err, true); })
        .finally(function () { if (button) button.disabled = false; });
    });
  }
  function init() { document.querySelectorAll('form[data-ucmn-nl]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
